export const GLOBAL_PANEL_TYPE = {
    PATIENT: 'patient',
    WARD_MAP: 'wardMap',
    SEARCH: 'search',
    OBSERVATIONS: 'observations',
};

export const GLOBAL_PANEL_ACTION_TYPE = {
    TIMELINE: 'timeline',
    ADMITTANCE: 'admittance',
    TASKS: 'tasks',
    ICE: 'ice',
    CLINICAL_NOTE: 'clinicalNote',
    BARCODE: 'barcode',
    SPLIT_SCREEN: 'splitScreen',

    SEARCH_TYPE: 'searchType',
    SEARCH_PATIENT_MODE: 'searchPatientMode',
    AGE_SEARCH: 'ageSearch',
    ADVANCE_SEARCH: 'advanceSearch',
    SEARCH_RESET_FILTER: 'searchResetFilter',

    CANCEL_OBSERVATION: 'cancelObservation',
    DEFER_OBSERVATION: 'deferObservation',
    SUSPEND_OBSERVATION: 'suspendObservation',
    UNPAUSE_OBSERVATION: 'unpauseObservation',
    NON_CONTACT_OBSERVATION: 'nonContact',
    NEURO_OBSERVATION: 'neuroObs',
    NEWS_OBSERVATION: 'obs',
    CHANGE_OBSERVATION_TYPE: 'changeObservationType',

    WARD_LAYER: 'wardLayer',
    WARD_FILTERS: 'wardFilters',
    WARD_ACTION: 'wardAction',
    WARD_SPECIALTY: 'wardSpecialty',
    WARD_MULTISELECT: 'wardMultiselect',
    SCHEDULER: 'scheduler',
    WARD_ESCALATION: 'wardEscalation',
    DASHBOARD: 'dashboard',
    ADMITTING_CONSULTANT: 'admittingConsultant',
    EXTERNAL_LINKS: 'externalLinks',
    AUDIT: 'audit',
};

export const GLOBAL_PANEL_ACTION_TYPE_BUTTON = {
    BUTTON: 'button',
    SWITCH_BLOCK: 'switchBlock',
    DIVIDER: 'divider',
    WARD_LAYER: 'wardLayer',
}